<template>
  <ul class="pagination">
    <li>
      <button
        type="button"
        class="pagination-btn"
        @click.stop="onClickPreviousPage"
        :disabled="isInFirstPage"
      >
        <ChevLeft />
      </button>
    </li>
    <li v-for="page in pages" :key="page">
      <div
        :class="[
          currentPage === page ? 'active' : '',
          'pagination-item',
          page === '...' && 'disabled_pagination',
        ]"
        style="display: flex; justify-content: center; align-items: center"
        type="button"
        @click="onClickPage(page)"
      >
        {{ page }}
      </div>
    </li>
    <li>
      <button
        type="button"
        class="pagination-btn"
        @click.stop="onClickNextPage"
        :disabled="isInLastPage"
      >
        <ChevRight />
      </button>
    </li>
  </ul>
</template>

<script>
import ChevRight from "../icons/ChevRight.vue";
import ChevLeft from "../icons/ChevLeft.vue";
export default {
  data() {
    return {};
  },
  props: {
    maxPages: {
      type: Number,
      required: false,
      default: 3,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },

  components: {
    ChevLeft,
    ChevRight,
  },
  computed: {
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.pages.length;
    },
    pages() {
      const pages = [];

      pages.push(this.currentPage);

      let leftRange = this.currentPage - 1;
      let rightRange = this.currentPage + 1;
      while (
        pages.length < this.maxPages &&
        (leftRange > 0 || rightRange <= this.totalPages)
      ) {
        if (leftRange > 0) {
          pages.unshift(leftRange);
          leftRange--;
        }

        if (pages.length < this.maxPages && rightRange <= this.totalPages) {
          pages.push(rightRange);
          rightRange++;
        }
      }

      // Add ellipses if necessary
      if (pages[0] > 1) {
        pages.unshift("..");
        pages.unshift(1);
      }
      if (pages[pages.length - 1] < this.totalPages) {
        pages.push("...");
        pages.push(this.totalPages);
      }
      return pages;
    },
  },
  methods: {
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage() {
      if (this.currentPage === this.pages.length) {
        return;
      }
      this.$emit("pagechanged", this.currentPage + 1);
    },
  },
};
</script>
